export default "__VITE_PUBLIC_ASSET__e2639c04__"